import { InputBase } from '@mui/material';
import React from 'react';

interface SearchBarProps {
    term: string;
    onTermChange: (term: string) => void;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
}
const SearchBar = ({
    term,
    onTermChange,
    placeholder,
    className,
    disabled,
}: SearchBarProps) => {
    return (
        <div className="search-bar-input rounded-8 py-4 px-8">
            <InputBase
                className={className}
                value={term}
                onChange={(e) => {
                    onTermChange(e.target.value);
                }}
                placeholder={placeholder ?? 'Search...'}
                disabled={disabled}
            />
        </div>
    );
};

export default SearchBar;
